import { EventEmitter } from '../util/eventemitter';

export class TradeData extends EventEmitter {
  exists: boolean;
  otherName: string;
  myItems: Map<number, any>;
  theirItems: Map<number, any>;
  myZuly: number;
  theirZuly: number;
  myConfirmed: boolean;
  theirConfirmed: boolean;

  constructor() {
    super();
    this.clear();
  }

  open(otherName: string) {
    this.clear(true);
    this.exists = true;
    this.otherName = otherName;
    this.emit('changed');
  }

  clear(silent = false) {
    this.exists = false;
    this.otherName = '';
    this.myItems = new Map();
    this.theirItems = new Map();
    this.myZuly = 0;
    this.theirZuly = 0;
    this.myConfirmed = false;
    this.theirConfirmed = false;
    if (!silent) {
      this.emit('changed');
    }
  }

  addMyItem(slotNum: number, item: any) {
    this.myItems.set(slotNum, item);
    this.myConfirmed = false;
    this.theirConfirmed = false;
    this.emit('changed');
  }

  removeMyItem(slotNum: number) {
    this.myItems.delete(slotNum);
    this.myConfirmed = false;
    this.theirConfirmed = false;
    this.emit('changed');
  }

  addTheirItem(slotNum: number, item: any) {
    this.theirItems.set(slotNum, item);
    this.myConfirmed = false;
    this.theirConfirmed = false;
    this.emit('changed');
  }

  removeTheirItem(slotNum: number) {
    this.theirItems.delete(slotNum);
    this.myConfirmed = false;
    this.theirConfirmed = false;
    this.emit('changed');
  }

  setMyZuly(amount: number) {
    this.myZuly = amount;
    this.myConfirmed = false;
    this.theirConfirmed = false;
    this.emit('changed');
  }

  setTheirZuly(amount: number) {
    this.theirZuly = amount;
    this.myConfirmed = false;
    this.theirConfirmed = false;
    this.emit('changed');
  }

  setMyConfirmed(confirmed: boolean) {
    this.myConfirmed = confirmed;
    this.emit('changed');
  }

  setTheirConfirmed(confirmed: boolean) {
    this.theirConfirmed = confirmed;
    this.emit('changed');
  }
}
